import isAndroid from '@/utils/IsAndroid';
import isIOS from '@/utils/IsIOS';
import '@assets/fonts/Roboto/Roboto-Bold-normal';
import '@assets/fonts/Roboto/Roboto-Regular-normal';
import { jsPDF } from 'jspdf';

const pdfGenerator = async (html: string) => {
  const pdf = new jsPDF({
    orientation: 'p',
    format: 'a4',
    unit: 'px',
    hotfixes: ['px_scaling'],
  });

  pdf.setFont('Roboto-Regular');
  await pdf.html(html.replace('{{customFont}}', ''), {
    x: 0,
    y: 0,
    width: 793.706,
    windowWidth: 793.706,
    filename: 'Rapport.pdf',
    autoPaging: 'text',
    margin: isIOS() || isAndroid() ? 10 : 10,
    html2canvas: {
      width: 793.706,
      windowWidth: 793.706,
      windowHeight: 1100.706,
      scale: isIOS() || isAndroid() ? 0.955 : 0.955,
    },
  });

  return { uri: pdf.output('bloburi') };
};

export const downloadFile = (uri: string, fileName: string) => {
  const link = document.createElement('a');
  // create a blobURI pointing to our Blob
  link.href = uri;
  link.download = fileName;
  // some browser needs the anchor to be in the doc
  document.body.append(link);
  link.click();
  link.remove();
  // in case the Blob uses a lot of memory
  setTimeout(() => URL.revokeObjectURL(link.href), 7000);
};

export default pdfGenerator;
